import React, { useState, useEffect } from 'react';
import { Container, Table, Alert } from 'react-bootstrap';
import { useLocation, Link } from 'react-router-dom';
import { FaDownload } from 'react-icons/fa';
import { buildUrl } from '../helper/handler';
import { getFromApi, downloadFile } from '../utilities/NetUtilities';
import { SpinnerComp } from '../helper/spinner';
import moment from 'moment';

function FreezeFilesObiettivo730() {
    const location = useLocation();
    const query = new URLSearchParams(location.search);
    const id = query.get('id');
    const [files, setFiles] = useState([]);
    const [loading, setLoading] = useState(true);
    const [message, setMessage] = useState(null);

    useEffect(() => {
        loadFiles();
    }, [id]);

    const loadFiles = () => {
        setLoading(true);
        const url = buildUrl('obiettivi730freezefiles', { obiettivoId: id });
        getFromApi(url, (data) => {
            setFiles(data.files || []);
            setLoading(false);
        }, (err) => {
            setMessage({ tipo: "danger", descrizione: "Errore nel caricamento dei file" });
            setLoading(false);
        });
    };

    const handleDownload = (filename) => {
        const url = buildUrl('obiettivi730freeze/download', { obiettivoId: id, filename: filename });
        downloadFile(url, filename);
    };

    const formatTimestamp = (timestamp) => {
        return moment(timestamp).format('DD/MM/YYYY HH:mm:ss');
    };

    const formatSize = (bytes) => {
        if (bytes === 0) return '0 Bytes';
        const k = 1024;
        const sizes = ['Bytes', 'KB', 'MB', 'GB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    };

    if (loading) {
        return <div className="d-flex justify-content-center mt-5"><SpinnerComp /></div>;
    }

    return (
        <div className='main' role="main">
            <Container>
                <h1 className="d-flex justify-content-center inEvidenza">File freeze obiettivo</h1>
                {message && <Alert variant={message.tipo} className='mt-3'>{message.descrizione}</Alert>}
                
                <div className="d-flex justify-content-start mb-3">
                    <Link to="/obiettivi730" className="btn btnGenerale">Indietro</Link>
                </div>

                {files.length > 0 ? (
                    <Table striped bordered hover responsive size="sm">
                        <thead>
                            <tr>
                                <th>Nome file</th>
                                <th className="text-center">Dimensione</th>
                                <th className="text-center">Data creazione</th>
                                <th className="text-center">Azioni</th>
                            </tr>
                        </thead>
                        <tbody>
                            {files.map((file, idx) => (
                                <tr key={idx}>
                                    <td>{file.name}</td>
                                    <td className="text-right">{formatSize(file.size)}</td>
                                    <td className="text-center">{formatTimestamp(file.lastModified)}</td>
                                    <td className="text-center">
                                        <div className="actionIconContainer">
                                            <FaDownload
                                                className='actionIcon'
                                                onClick={() => handleDownload(file.name)}
                                                title="Download CSV"
                                                id={'freeze-' + idx}
                                            />
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                ) : (
                    <p className="text-center mt-5">Nessun file freeze generato per questo obiettivo.</p>
                )}
            </Container>
        </div>
    );
}

export default FreezeFilesObiettivo730;